function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "testing",
  transform: "translate(1.000000, 1.000000)",
  stroke: "currentColor",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "21.472 37.4996 21.472 15.7731 37.9999 9.9059 37.9999 31.2872"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "16.5278 37.5542 16.5278 15.8278 -5.5e-05 9.9606 -5.5e-05 31.3419"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "19.0523 11.7323 35.8442 5.79017 19.0523 0.05624 2.12207 5.79018"
})));

var SvgIcSidemenuProduct = function SvgIcSidemenuProduct(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcSidemenuProduct, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_sidemenu_product.ea72199d.svg";
export { ForwardRef as ReactComponent };